@if (currentUser(); as user) {
  <app-page-header title="Мій профіль"></app-page-header>

  <div class="grid grid-cols-12 gap-6">
    <div class="col-span-12 lg:col-span-8">
      <p-card>
        <div class="flex items-center mb-6">
          <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-full mr-4 shrink-0"
               style="width: 64px; height: 64px; font-size: 1.5rem;">
            <span class="text-blue-500 font-semibold">{{ avatarInitials() }}</span>
          </div>
          <div>
            <h2 class="text-xl font-bold mt-0 mb-1">{{ user.employee?.name }} {{ user.employee?.surname }}</h2>
            <div class="flex items-center gap-2">
              <span class="text-muted-color">{{ user.email }}</span>
              <p-tag value="Активний" severity="success" />
            </div>
          </div>
        </div>

        <p-divider />

        <div class="grid grid-cols-12 gap-6 mt-4">
          <div class="col-span-12 md:col-span-6">
            <label class="block text-sm text-muted-color uppercase font-bold mb-1">Електронна пошта</label>
            <p class="mb-0 font-mono">{{ user.email }}</p>
          </div>
          <div class="col-span-12 md:col-span-6">
            <label class="block text-sm text-muted-color uppercase font-bold mb-1">Номер телефону</label>
            <p class="mb-0">{{ user.phone || '—' }}</p>
          </div>
          <div class="col-span-12 md:col-span-6">
            <label class="block text-sm text-muted-color uppercase font-bold mb-1">Ім'я</label>
            <p class="mb-0">{{ user.employee?.name || '—' }}</p>
          </div>
          <div class="col-span-12 md:col-span-6">
            <label class="block text-sm text-muted-color uppercase font-bold mb-1">Прізвище</label>
            <p class="mb-0">{{ user.employee?.surname || '—' }}</p>
          </div>
          <div class="col-span-12 md:col-span-6">
            <label class="block text-sm text-muted-color uppercase font-bold mb-1">Дата створення</label>
            <p class="mb-0">
              <app-ukr-date-time [dateTime]="user.created_at"></app-ukr-date-time>
            </p>
          </div>
          <div class="col-span-12 md:col-span-6">
            <label class="block text-sm text-muted-color uppercase font-bold mb-1">ID Користувача</label>
            <p class="mb-0 font-mono text-muted-color text-sm">{{ user.id }}</p>
          </div>
        </div>
      </p-card>
    </div>

    <div class="col-span-12 lg:col-span-4">
      <p-card>
        <ng-template #header>
          <div class="px-5 pt-5">
            <h3 class="text-lg font-semibold m-0 flex items-center gap-2">
              <i class="pi pi-shield"></i> Ролі та дозволи
            </h3>
          </div>
        </ng-template>

        <div class="flex flex-col gap-4">
          <div>
            <label class="block text-sm text-muted-color uppercase font-bold mb-1">Ролі</label>
            <div class="flex flex-wrap gap-2">
              @for (role of user.roles; track role) {
                <p-tag [value]="role | uppercase" severity="secondary" />
              } @empty {
                <span class="text-muted-color text-sm">Ролі відсутні</span>
              }
            </div>
          </div>

          @if (user.permissions && user.permissions.length > 0) {
            <div>
              <label class="block text-sm text-muted-color uppercase font-bold mb-1">Дозволи</label>
              <div class="flex flex-wrap gap-2">
                @for (permission of user.permissions; track permission) {
                  <p-tag [value]="permission" severity="info" />
                }
              </div>
            </div>
          }
        </div>
      </p-card>
    </div>
  </div>
} @else {
  <app-page-header title="Мій профіль"></app-page-header>
  <div class="flex justify-center py-8">
    <p-progressSpinner styleClass="w-12 h-12" />
  </div>
}
